import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ts_phuhuynh_adm_status } from './../../../models/response/category/ts_phuhuynh_adm_status';
import { ITrangThaiPhuHuynhCoSoItemResponse } from './../../../models/response/category/ITrangThaiPhuHuynhCoSoItemResponse';

export const objTrangThaiPhuHuynhDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as ts_phuhuynh_adm_status[],
    LOAD_ERROR: "",

    LOAD_CHECKDANGKY_START: 0,
    LOAD_CHECKDANGKY_SUCCESS: [] as ITrangThaiPhuHuynhCoSoItemResponse[],
    LOAD_CHECKDANGKY_ERROR: "",

    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as ITrangThaiPhuHuynhCoSoItemResponse[],
    LOAD_COSO_ERROR: "",

    SHOW_EDIT_MODAL: {} as ts_phuhuynh_adm_status | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ts_phuhuynh_adm_status,
    SAVE_SUCESS: {} as ts_phuhuynh_adm_status,
    SAVE_ERROR: "",

    // INSERT_START: {} as ITrangThaiPhuHuynh,
    // INSERT_SUCCESS: {} as ITrangThaiPhuHuynh,
    // INSERT_ERROR: "",

    INSERT_MULTIPLE_START: {} as ITrangThaiPhuHuynhCoSoItemResponse,
    INSERT_MULTIPLE_SUCCESS: {} as ITrangThaiPhuHuynhCoSoItemResponse,
    INSERT_MULTIPLE_ERROR: "",

    UPDATE_START: {} as ts_phuhuynh_adm_status,
    UPDATE_SUCCESS: {} as ts_phuhuynh_adm_status,
    UPDATE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

};

export const eTrangThaiPhuHuynhActionTypeIds = generateActionTypeIds(objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH")
export type ITrangThaiPhuHuynhActionTypes = IGenericActionType<typeof objTrangThaiPhuHuynhDefine, "TRANG_THAI_PHU_HUYNH">
